<div class="is-relative">
    <div class="content-type-form">
        <div class="is-flex is-space-between">
            <ng-container *ngIf="active; else activation">
                <h2 class="title is-2 is-flex has-items-centered">
                    <p class="has-text-success">
                        <isav-icon icon="circle"></isav-icon>
                    </p>
                    <span>&nbsp;Active</span>
                </h2>
                <div class="buttons is-right">
                    <button type="button" isavBtn color="danger" (click)="deactivate()">
                        Deactivate
                    </button>
                </div>
            </ng-container>
            <ng-template #activation>
                <h2 class="title is-2 is-flex has-items-centered">
                    <p class="has-text-danger">
                        <isav-icon icon="circle"></isav-icon>
                    </p>
                    &nbsp;Not active
                </h2>
                <div class="buttons is-right">
                    <button type="button" isavBtn color="success" (click)="activate()">
                        Activate
                    </button>
                </div>
            </ng-template>
        </div>

        <h2 class="title is-2">Change roles</h2>
        <div class="columns">
            <div class="column is-10">
                <isav-select-input
                    label="Roles"
                    [formControl]="rolesControl"
                    placeholder="Select roles"
                    [options]="roles"
                    multiple
                >
                </isav-select-input>
            </div>
            <div class="column is-2 has-text-right">
                <button type="button" isavBtn color="success" (click)="changeRoles()">Save</button>
            </div>
        </div>

        <h2 class="title is-2">Change password</h2>
        <form ngNoForm class="columns">
            <div class="column is-10">
                <input
                    style="display: none"
                    type="text"
                    [value]="value.email"
                    autocomplete="username"
                />
                <isav-password-input label="New password" [formControl]="passwordControl">
                </isav-password-input>
            </div>
            <div class="column is-2 has-text-right">
                <button
                    type="button"
                    isavBtn
                    color="success"
                    [disabled]="!passwordControl.valid"
                    (click)="changePassword()"
                >
                    Save
                </button>
            </div>
        </form>
    </div>
    <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
</div>
